<script setup>
import { ref } from "vue";
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useAuthStore } from "../store/auth";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import imgLogin from "../assets/img/shapes/fondo-ontrix-vertical.jpg";
import imgLogo from "../assets/img/logos/logo-ontrix-blanco.png"
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import FullScreenLoader from "@/components/FullScreenLoader.vue";

import {
  isValidEmail,
  isPassword,
} from "../utils/validations/validationsInputs.js";
import { loaderState, showLoader, hideLoader } from "../utils/loader/loader.js";

const body = document.getElementsByTagName("body")[0];
const router = useRouter();
const store = useStore();
const authStore = useAuthStore();
const email = ref("");
const password = ref("");
const showPassword = ref(false);
const loginPlanta = ref(imgLogin);
const logo = ref(imgLogo);
const errors = ref({});
const loadingPercentage = ref(0);

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

// Validaciones
const validateField = (field) => {
  if (field === "email") {
    if (!email.value) {
      errors.value.email = "El campo correo es obligatorio.";
      return;
    }
    const result = isValidEmail(email.value);
    errors.value.email = typeof result === "string" ? result : null;
  }

  if (field === "password") {
    if (!password.value) {
      errors.value.password = "El campo contraseña es obligatorio.";
      return;
    }
    if (password.value.length > 8) {
      errors.value.password =
        "La contraseña no puede tener más de 8 caracteres.";
      return;
    }
    const result = isPassword(password.value);
    errors.value.password = typeof result === "string" ? result : null;
  }
};

const validateForm = () => {
  validateField("email");
  validateField("password");
  return Object.keys(errors.value).every((key) => !errors.value[key]);
};

// Método de login
const login = async () => {
  if (!validateForm()) {
    return;
  }
  showLoader();

  loadingPercentage.value = 100;
  const response = await authStore.login({
    usuario: email.value,
    password: password.value,
    ip: "205.345.34.23",
  });
  if (response.ok) {
    router.push("code");
  } else {
    toast.error(response.message);
  }
  hideLoader();
};

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};
</script>

<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Iniciar sesión</h4>
                  <p class="mb-0">
                    Ingresa tu correo electrónico y contraseña para iniciar
                    sesión.
                  </p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="login">
                    <div class="mb-3">
                      <argon-input
                        id="email"
                        v-model="email"
                        placeholder="Correo"
                        name="email"
                        size="lg"
                        @input="validateField('email')"
                      />
                      <div v-if="errors.email" class="text-danger text-sm">
                        {{ errors.email }}
                      </div>
                    </div>
                    <div class="mb-3 posi-relative">
                      <argon-input
                        id="password"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Contraseña"
                        name="password"
                        v-model="password"
                        size="lg"
                        maxlength="8"
                        @change="validateField('password')"
                      />
                      <button
                        type="button"
                        class="btn-password-view"
                        @click="togglePasswordVisibility"
                      >
                        <i
                          :class="
                            !showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                          "
                        ></i>
                      </button>
                      <div v-if="errors.password" class="text-danger text-sm">
                        {{ errors.password }}
                      </div>
                    </div>

                    <div class="text-center">
                      <argon-button class="mt-4" fullWidth size="lg"
                        >Iniciar</argon-button
                      >
                    </div>
                  </form>
                  <br>
                  <p class="text-justify text-sm">
                  Si ha olvidado su contraseña o presenta dificultades para
                  acceder al sistema, solicitamos enviar un correo electrónico a
                  <a
                    href="mailto:soporte@afcoma.com.mx"
                    class="fw-bold"
                  >
                   <strong>soporte@afcoma.com.mx</strong> 
                  </a>
                  describiendo detalladamente la situación.
                  Nuestro equipo de soporte le asistirá.
                </p>
                </div>
               
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${loginPlanta})`,
                  backgroundSize: 'cover',
                }"
              >
                <!-- <span class="mask bg-gradient-success opacity-3"></span> -->
                <img :src="logo" alt="Ontrix" class="logo-ontrix" />

              </div>
            </div>
          </div>
        </div>
      </div>

      <full-screen-loader :isVisible="loaderState.isVisible" />
    </section>
  </main>
</template>
<style scoped>
.posi-relative {
  position: relative;
}
.btn-password-view {
  position: absolute;
  /* top: 50%; */
  right: 10px;
  transform: translateY(-174%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #6c757d;
}
.logo-ontrix {
  width: 60%;  /* ajusta el tamaño del logo */
  margin-top:-22px;
  margin-left: 24%;
}
.btn-password-view:hover {
  color: #000; /* Cambia el color al pasar el mouse */
}
</style>
